module.exports = __webpack_public_path__ + "img/swiper-img2.07180524.png";